import React,{useState,useEffect} from 'react';
import styles from './EnterAmount.module.scss';
import { FieldType } from 'common/consts/fieldType';
import { isNullOrWhiteSpace } from 'common/helpers/string';

interface Props {
    Model?: any; // Data from backend
    PageData?: any;
    handleClick:any;
    disposableIncomeAmount:any;
    incomeAmountForCalculation:Function;
    showCalculation:boolean;
    setCollapseCalculation: any;
    currencyClass: any;
}

const EnterAmount = ({
    Model,
    PageData,
    handleClick,
    disposableIncomeAmount,
    incomeAmountForCalculation,
    showCalculation,
    setCollapseCalculation,
    currencyClass
}: Props) => {

    const handleCollapse =() =>{ 
        handleClick(!showCalculation); 
        setCollapseCalculation(!showCalculation);       
    }    
    
    const [incomeAmount, setIncomeAmount] = useState(Model?.FormModel.DisposableIncome); 
    
    function onChangeDisposableIncome(e: any) {
        setIncomeAmount(e.target.value);
        incomeAmountForCalculation(e.target.value);
    }

    function totalIncome() {
        
        if(disposableIncomeAmount!==null)
        {
            setIncomeAmount(disposableIncomeAmount);
        }
        
        else
        {           
            setIncomeAmount(Model?.FormModel.DisposableIncome);            
        }
        
    }

    function assignCalculationIncomeAMount(){
        incomeAmountForCalculation(incomeAmount);
    }

    const preventMinus = (e:any) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    useEffect(() => {
        totalIncome();        
    },[disposableIncomeAmount]);

    useEffect(() => {
        setIncomeAmount(Model?.FormModel.DisposableIncome);        
    },[Model]);

    return (
        <div className="Grid Grid-spacingB Grid--gutterH Grid--white GridWhite--smFull">
                    <div className="Grid-cell Grid--alignCenter">
                        <div className="Grid-cell u-paddingHz u-textCenter">
                            <h3 className="Heading Heading--hasIcon  Heading--hasIcon-center Heading-h3--portal">{PageData.EnterDisposableIncomeHeader}<i className="u-hidden u-md-block"><img src={`${process.env.PUBLIC_URL}/images/icons/calculator.svg`} alt="calculator"/></i></h3>

                            <p className="u-inlineBlock u-textWeightBold u-textPlatform u-marginBxxsm">
                                {PageData.EnterDisposableIncomeLabelText}
                            </p>
                            {(!isNullOrWhiteSpace(Model?.PageDataBase.EnterDisposableIncomeToolTip) || Model.edit===true) &&
                            (
                                <div className="Tooltip Tooltip--info js-tooltipOpen">
                                    <span className="Tooltip Tooltip-content">
                                        <p className="Tooltip Tooltip-text">
                                            <span className="Tooltip-button js-tooltipOpen"></span>
                                            {PageData?.EnterDisposableIncomeToolTip}
                                        </p>
                                    </span>
                                </div>
                            )}                            

                        </div>
                        <div className="Grid-cell Grid-cell--center u-md-size1of2 u-paddingVz">
                            <div className={'Input Input-icon Input-icon--before ' + currencyClass + ' Input-textCenter u-marginBxxsm'}>
                                <input type="text"
                                value={incomeAmount}                                
                                className = "form-control h-input h-amount-input" 
                                tabIndex={1} v-model="disposableIncome" autoComplete="off" 
                                placeholder='0.0' inputMode='decimal' step="0.01"
                                onChange={(val) => { onChangeDisposableIncome(val);}}
                                onKeyPress={preventMinus}/>
                                <span></span>
                            </div>
                            <p className="Text--small u-textCenter u-colorTextLightGray u-marginTxxxsm">
                                {PageData.EnterAnAmountLabelText}
                            </p>
                        </div>
                        <div className="CreateRepaymentPlan-divider"></div>
                    </div>
                    <div className="Grid-cell u-textCenter u-marginVxxsm">
                        <p className="u-marginBxxsm Text--medium">{PageData.EnterDisposableIncomeNeedHelpLabelText}</p>
                        <a id="lnk-show-calc" onClick={handleCollapse} className="Link Link-alone Link--magenta Text--medium" data-toggle="collapse"  role="button" aria-expanded="false" aria-controls="collapseExample">
                            {PageData.CalculateDisposableIncomeLabelText}
                        </a>
                    </div>
        </div>
                
            
    );

};

export default EnterAmount;